import { MenuItem } from 'primeng/api';
import { Avatar } from 'primeng/avatar';
import { Router } from '@angular/router';
import { Menubar } from 'primeng/menubar';
import { TieredMenu } from 'primeng/tieredmenu';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { AuthService } from '../../../../core/services/auth.service';
import { UserDisplayService } from '../../../services/user-display.service';

@Component({
    selector: 'app-support-header',
    templateUrl: './support-header.component.html',
    styleUrl: './support-header.component.css',
    imports: [Avatar, Menubar, TieredMenu, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportHeaderComponent implements OnInit {
    public userMenuItems: MenuItem[] = [];

    private readonly router = inject(Router);
    private readonly authService = inject(AuthService);
    public readonly userDisplay = inject(UserDisplayService);

    ngOnInit(): void {
        this.buildUserMenuItems();
    }

    /**
     * Constructs user menu items with sign out option only.
     */
    private buildUserMenuItems(): void {
        this.userMenuItems = [
            {
                label: 'Sign Out',
                icon: 'pi pi-sign-out',
                command: () => this.logout()
            }
        ];
    }

    /**
     * Logs the user out of the application.
     */
    public logout(): void {
        this.authService.signOut();
        this.router.navigateByUrl('/auth/sign-in', { replaceUrl: true }).then();
    }
}
